import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  HeadObject: {
    A_VocTyp: "",
    A_VocTypName: "",
    A_VocNo: "0",
    A_PostDt: new Date(),
    A_RefDt: new Date(),
    A_RefNo: "",
    A_Party: "",
    A_PartyName: "",
    A_Curr: "",
    A_Currname: "",
    A_ExRate: "1",
    A_PayMode: "CASH",
    A_Type: "Retail",
    A_Loc: "",
    A_Buyer: "", ////SalesMan
    A_Narr: "",
    A_CrAc: "",
    A_CrAcName: "",
    A_DrAc: "",
    A_DrAcName: "",
    A_DiscPerc: (0).toFixed(2),
    A_DiscAmt: (0).toFixed(2),
    A_Rounding: (0).toFixed(2),
    A_NetAmt: 0,
    A_LC: 0,
    A_Charges1: 0,
    A_Charges2: 0,
    A_DocStat: "ENTER",
    A_CUSTFIELD1: "",
    A_CUSTFIELD2: "", //SalesGroup
    A_CUSTFIELD3: "OTTRN001",
    A_CUSTFIELD4: "N",
    A_CUSTFIELD5: "", //-- LOading Pay ,
    A_CUSTFIELD6: "",
    A_CUSTFIELD7: "",
    A_CUSTFIELD8: "",
    A_CUSTFIELD9: "",
    A_CUSTFIELD10: "",
    A_ExciseTaxNetAmt: 0,
    PKD: "N",
    A_TaxGross: "N",
    A_Taxable: "Y",
    LDP: "N",
    A_Party_TRN: "",
    A_Br_TRN: "",
    A_GST_Type: "",
    A_NetAmt_Arabic: "",
    A_VATRefNo: "",
    A_InstantPick: "N",
    A_INV_TYPE: "Walk-In",
  },
  // BufferObject: {
  //   B_VocTyp: "",
  //   B_VocNo: "",
  //   B_Srno: 0,
  //   B_Itmcd: "",
  //   B_ItmName: "",
  //   B_Qty: 0,
  //   B_Unit: "",
  //   B_UnitName: "",
  //   B_BaseQty: 0,
  //   B_URateFc: 0,
  //   B_URateLc: 0,
  //   B_GrossAmt: 0,
  //   B_LDiscPerc: 0,
  //   B_LDiscAmt: 0,
  //   B_TDiscPerc: 0.00,
  //   B_TDiscAmt: 0,
  //   B_FocFlag: "N",
  //   B_AprmtFlag: "",
  //   B_FocAmt: 0,
  //   B_NetAmt: 0,
  //   B_TaxDept: "",
  //   B_TaxPerc: 0,
  //   B_TaxAmt: 0,
  //   B_TaxDept2: "",
  //   B_TaxPerc2: 0,
  //   B_TaxAmt2: 0,
  //   B_LC: 0,
  //   B_Charges1: 0,
  //   B_Charges2: 0,
  //   B_Rounding: 0,
  //   B_LandVal: 0,
  //   B_RSP: 0,
  //   B_RefDocTyp: "",
  //   B_RefDocNo: "",
  //   B_RefNo1: "",
  //   B_RefNo2: "",
  //   B_RefNo3: "",
  //   B_RefNo4: 0,
  //   B_RefNo5: 0,
  //   B_RefNo6: 0,
  //   B_URate_Fixed: 0,
  //   B_CostPr: 0,
  //   B_ExciseTaxPerc: 0,
  //   B_ExciseTaxAmt: 0,
  //   B_ExciseTaxNetAmt: 0,
  //   B_IncGroup: "",
  //   B_SuprvPerc: 0,
  //   B_OthersPerc: 0,
  //   B_SLANSuprv: "",
  //   B_SlabAmtSuprv: 0,
  //   B_SLANOther: "",
  //   B_SlabAmtOther: 0
  // },
  WmsInnContent: {},
  HeadPosMode: {
    PosMode: false,
  },
};

const SliceWmsInvoice = createSlice({
  name: "SliceWmsInvoice",
  initialState: { value: initialState },

  reducers: {
    WmsInvoiceHead_Set: (state, action) => {
      state.value = action.payload;
    },
    WmsInvoice_Init: (state) => {
      state.value = initialState;
    },
    WmsInvoice_HeadObject_Init: (state) => {
      state.value.HeadObject = initialState.HeadObject;
    },
    Wms_Invoice_HeadObject_Set: (state, action) => {
      state.value.HeadObject = action.payload;
    },
    Wms_Invoice_HeadPosMode_Set: (state, action) => {
      state.value.HeadPosMode.PosMode = action.payload.PosMode;
    },

    Wms_Invoice_BufferObject_Set: (state, action) => {
      state.value.BufferObject = action.payload;
    },

    Wms_Invoice_HeadObject_New_Set: (state, action) => {
      state.value.HeadObject.A_VocTyp = action.payload.A_VocTyp;
      state.value.HeadObject.A_VocTypName = action.payload.A_VocTypName;
      state.value.HeadObject.A_VocNo = action.payload.A_VocNo;
      state.value.HeadObject.A_Loc = action.payload.A_Loc;
      state.value.HeadObject.A_Curr = action.payload.A_Curr;
      state.value.HeadObject.A_ExRate = action.payload.A_ExRate;
      state.value.HeadObject.A_Type = action.payload.A_Type;
      state.value.HeadObject.A_Buyer = action.payload.A_Buyer;
      state.value.HeadObject.A_CUSTFIELD2 = action.payload.A_CUSTFIELD2;
      state.value.HeadObject.A_CUSTFIELD3 = action.payload.A_CUSTFIELD3;
      state.value.HeadObject.A_Party = action.payload.A_Party;
      state.value.HeadObject.A_PartyName = action.payload.A_PartyName;
      state.value.HeadObject.A_INV_TYPE = action.payload.A_INV_TYPE;
    },

    Wms_Invoice_HeadObject_DrCrAccount_Set: (state, action) => {
      state.value.HeadObject.A_CrAc = action.payload.A_CrAc;
      state.value.HeadObject.A_CrAcName = action.payload.A_CrAcName;
      state.value.HeadObject.A_DrAc = action.payload.A_DrAc;
      state.value.HeadObject.A_DrAcName = action.payload.A_DrAcName;
    },

    Wms_Invoice_HeadObject_A_Type_Set: (state, action) => {
      state.value.HeadObject.A_Type = action.payload.A_Type;
    },
    Wms_Invoice_HeadObject_A_VocNo_Set: (state, action) => {
      state.value.HeadObject.A_VocNo = action.payload.A_VocNo;
      state.value.HeadObject.A_DocStat = action.payload.A_DocStat;
    },
    Wms_Invoice_HeadObject_SalesGroup_SalesMan_Set: (state, action) => {
      state.value.HeadObject.A_Buyer = action.payload.A_Buyer;
      state.value.HeadObject.A_CUSTFIELD2 = action.payload.A_CUSTFIELD2;
    },
    Wms_Invoice_HeadObject_A_DocStatus_Set: (state, action) => {
      state.value.HeadObject.A_DocStat = action.payload.A_DocStat;
    },
    Wms_Invoice_HeadObject_A_Party_Set: (state, action) => {
      state.value.HeadObject.A_Party = action.payload.A_Party;
      state.value.HeadObject.A_PartyName = action.payload.A_PartyName;
    },

    Wms_Invoice_HeadObject_A_PayMode_Set: (state, action) => {
      state.value.HeadObject.A_PayMode = action.payload.A_PayMode;
    },

    Wms_Invoice_ContentObject_Set: (state, action) => {
      state.value.WmsInnContent = action.payload;
    },
  },
});

export const {
  WmsInvoice_Init,
  Wms_Invoice_HeadObject_Set,
  Wms_Invoice_BufferObject_Set,
  Wms_Invoice_ContentObject_Set,
  Wms_Invoice_HeadObject_New_Set,
  Wms_Invoice_HeadObject_A_VocNo_Set,
  Wms_Invoice_HeadObject_DrCrAccount_Set,
  Wms_Invoice_HeadObject_A_DocStatus_Set,
  Wms_Invoice_HeadObject_A_PayMode_Set,
  Wms_Invoice_HeadObject_SalesGroup_SalesMan_Set,
  Wms_Invoice_HeadObject_A_Party_Set,
  Wms_Invoice_HeadPosMode_Set,
  Wms_Invoice_HeadObject_A_Type_Set,
  WmsInvoice_HeadObject_Init,
} = SliceWmsInvoice.actions;
export default SliceWmsInvoice.reducer;
